import "./App.css";
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Home from "./components/Pages/Home/home";
import Album from "./components/Pages/Album/album";
import Project from "./components/Pages/Project/project";
import Trivia from "./components/Pages/Trivia/trivia";
import Header from "./components/Layout/Header/header";
import Footer from "./components/Layout/Footer/footer";
import Sidebar from "./components/Layout/Sidebar/sidebar";
import LoginPage from "./components/Pages/loginPage";
import RegisterPage from "./components/Pages/registerPage";
import Logout from "./components/Auth/logout";
import NotFound from "./components/Pages/404";
import ForgotPage from "./components/Pages/forgotPage";
import ResetPage from "./components/Pages/resetPage";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Sidebar />
        <main>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/proyecto" element={<Project />} />
            <Route path="/album" element={<Album />} />
            <Route path="/trivia" element={<Trivia />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/registrarse" element={<RegisterPage />} />
            <Route path="/recuperar" element={<ForgotPage />} />
            <Route path="/restablecer" element={<ResetPage />} />
            <Route path="/404" component={<NotFound />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </AuthProvider>
  );
}

export default App;
